import MaterialTable, { MTableToolbar } from "material-table";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import SlidingPane from "react-sliding-pane";
import Select from "react-select";
import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable'


import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import AddcategoryService from "../../../services/category/categoryAddServices";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

function AssetRegister() {
  var contractNumber = "";
  var assetNumber = "";
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const tableRef = useRef();
  let navigate = useNavigate();

  const [selectedValue2, setSelectedValue2] = useState(null);
  const [options2, setOptions2] = useState([]);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);

  const [selectedValueAsset, setSelectedValueAsset] = useState(null);
  const [optionsAsset, setOptionsAsset] = useState([]);
  const [isLoadingAsset, setIsLoadingAsset] = useState(false);
  const [inputvalueAsset, setValueAsset] = useState("");
  const [currentPageAsset, setCurrentPageAsset] = useState(1);

  const [inputvalue, setValue] = useState("");
  const [status, setStatus] = useState("");
  const [asset_type, setAsset_type] = useState("");

  const [category_list, setCategory_list] = useState([]);
  const [sub_categories, setSub_categories] = useState([]);
  const [selected_category, setSelected_category] = useState("");
  const [selected_sub_category, setselected_sub_category] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [summaryData, setSummaryData] = useState([]);

  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");
  const handleClear = () => {
    // setSelectedValue(null);
    setSelectedValue2(null);
    setSelectedValueAsset(null);
    setStatus("");
    setValue("");
    setValueAsset("");
    setAsset_type("");
    setselected_sub_category("");
    setSelected_category("");

    tableRef.current.onQueryChange();
  };

  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleInputAssetChangeData = (value) => {
    setValueAsset(value);
    setCurrentPageAsset(1);
    setOptionsAsset([]);
    loadOptionsAssetData(value, 1);
  };

  const handlechangeAsset = (value) => {
    setSelectedValueAsset(value);
  };

  const handleAssetMenuScrollToBottom = () => {
    loadOptionsAssetData(inputvalueAsset, currentPageAsset);
  };

  const loadOptionsAssetData = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoadingAsset(true);
        const response = await fetch(
          `${API}contracts/asset/filter/?asset_number=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();
        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptionsAsset((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPageAsset((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoadingAsset(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoadingAsset(false);
    }
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoading2(true);
        const response = await fetch(
          // `${API}contracts/contractsactive/filter/?id=${value}&page=${page}`,
          `${API}contracts/contracts/filter/?id=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading2(false);
    }
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === "financed_amount") {
        alignmentStyles[index] = { halign: "right" };
      } else {
        alignmentStyles[index] = { halign: "left" };
      }
    });
    return alignmentStyles;
  }

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10; // Your page size

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: "",
      };

      // Modify the logic here to handle customerName if needed

      // if (selectedValue) {
      //   customerName = selectedValue.id;
      // }

      assetNumber = "";
      if (selectedValue2) {
        contractNumber = selectedValue2.contract_number;
      }

      if (selectedValueAsset) {
        assetNumber = selectedValueAsset.asset_number;
      }

      const url =
        API +
        "contracts/assetregister-view/?" +
        "&per_page=" +
        query.pageSize +
        "&page=" +
        (query.page + 1) +
        "&search=" +
        query.search +
        "&contractNumber=" +
        contractNumber +
        "&assetNumber=" +
        assetNumber;

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  const handleAssetView = (
    contract_id,
    conractstatus,
    contracttype,
    asset_id
  ) => {
    if (conractstatus === "Active" || conractstatus === "PaidOff") {
      navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id });
    } else if (conractstatus === "Terminated") {
      navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id });
    } else {
      if (contracttype === "Loan") {
        navigate(`/editloancontract?Asset=${asset_id}`, { state: contract_id });
      } else if (contracttype === "Rental") {
        navigate(`/editrentalcontract?Asset=${asset_id}`, {
          state: contract_id,
        });
      } else {
        navigate(`/contract/edit?Asset=${asset_id}`, { state: contract_id });
      }
    }
  };

  const handleViewRedirect = (id, status, contract_type) => {
    if (status === "Active" || status === "PaidOff") {
      navigate("/contract/view", { state: id });
    } else if (status === "Terminated") {
      navigate("/contract/view", { state: id });
    } else {
      if (contract_type === "Loan") {
        navigate("/editloancontract", { state: id });
      } else if (contract_type === "Rental") {
        navigate("/editrentalcontract", { state: id });
      } else {
        navigate("/contract/edit", { state: id });
      }
    }
  };

  const handleEdit = (id) => {
    navigate("/itemmasteredit", { state: id });
  };

  useEffect(() => {
    AddcategoryService.viewListCategory().then((response) => {
      setCategory_list(response.data.data.categories);
    });
  }, []);
  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setSelected_category(selectedValue);
    // handleItemType(selectedValue)
  };

  useEffect(() => {
    if (selected_category !== "") {
      const matchedCategory = category_list.find(
        (cat) => cat.id === Number(selected_category)
      );
      const category_name = matchedCategory.category_name;
      const item_types = matchedCategory?.item_type;
      AddcategoryService.filtersubCategory(category_name).then((response) => {
        const fetchedSubCategories = response.data.sub_categories;
        setSub_categories(fetchedSubCategories);
        const defaultSubCategory = fetchedSubCategories.find(
          (subCat) => subCat.is_default === true
        );
        if (defaultSubCategory) {
          setselected_sub_category(defaultSubCategory.id.toString());
        } else {
          setselected_sub_category("");
        }
      });
    }
  }, [selected_category, category_list]);

  const handlesubCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setselected_sub_category(selectedValue);
  };

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <div className="container-fluid">
        <MaterialTable
          tableRef={tableRef}
          style={{
            padding: "0.5rem 0.5rem",
            backgroundColor: "var(--bs-table-bg)",
            borderBottomWidth: "1px",
            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
          }}
          // title={<h5 className="mb-0">{t("Asset Register")}</h5>}
          title={
            <>
              <h5 className="mb-0">{t("Inventory Register")}</h5>

              <Typography
                variant="body2"
                style={{
                  color: "#245C7F",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={handleDialogOpen}
              >
                {t("Summary")}
              </Typography>
            </>
          }
          columns={[
            {
              title: `${t("Item Number")}`,
              field: "itemname",
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
              render: (rowData) => (
                <div
                  onClick={() =>
                    navigate(`/itemmasterview`, { state: rowData.id })
                  }
                >
                  <>
                    <div className="d-xl-none tc d-md-none d-lg-none ">
                      {t("Item Number")}
                    </div>
                    <div className="hyperlink">{rowData.itemname}</div>
                  </>
                </div>
              ),
            },
            {
              title: `${t("Item Type")}`,
              // field: "asset_desc",
              field: "item_type",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Item Type")}
                  </div>
                  <div>{rowData.item_type ? rowData.item_type : "None"}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Description")}`,
              // field: "asset_desc",
              field: "description",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Description")}
                  </div>
                  <div>
                    {rowData.description ? rowData.description : "None"}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Serial Number")}`,
              field: "serialnumber",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Serial Number")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {rowData.serialnumber}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },

            {
              title: `${t("Make")}`,
              field: "make",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Make")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {rowData.make}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },
            {
              title: `${t("Model")}`,
              field: "model",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Model")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {rowData.model}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },

            {
              title: `${t("Net Book Value")}`,
              field: "netbookvalue",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Net Book Value")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {rowData.netbookvalue}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },
            {
              title: `${t("Contract Number")}`,
              // field: "contractname",
              field: "contract_number",
              render: (rowData) => (
                <div>
                  <>
                    <div className="d-xl-none tc d-md-none d-lg-none">
                      {t("Contract Number")}
                    </div>
                    <div
                      className="hyperlink"
                      onClick={() =>
                        handleViewRedirect(
                          rowData.contract_id,
                          rowData.conractstatus,
                          rowData.contracttype
                        )
                      }
                    >
                      {rowData.contract_number ? rowData.contract_number : ""}
                    </div>
                  </>
                </div>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Asset No")}`,
              field: "asset_number",
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
              render: (rowData) => (
                <div>
                  <>
                    <div className="d-xl-none tc d-md-none d-lg-none ">
                      {t("Asset No")}
                    </div>
                    <div
                      className="hyperlink"
                      onClick={() =>
                        handleAssetView(
                          rowData.contract_id,
                          rowData.conractstatus,
                          rowData.contracttype,
                          rowData.asset_id
                        )
                      }
                    >
                      {rowData.asset_number}
                    </div>
                  </>
                </div>
              ),
            },
            {
              title: `${t("Manufacturer")}`,
              field: "manufacturer",
              hidden: true,
              hiddenByColumnsButton: true,
              width: "100px",
              render: (rowData) => {
                const manufacturer = rowData?.manufacturer || "-";
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Manufacturer")}
                  </div>
                  <div>{manufacturer}</div>
                </>;
              },
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
                height: "auto",
                width: "200px",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
                height: rowData?.height || "auto",
                width: rowData?.width || "200px",
              }),
            },
            {
              title: `${t("Year of Manufacture")}`,
              field: "yearofmanufacture",
              hidden: true,
              hiddenByColumnsButton: true,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Year of Manufacture")}
                  </div>
                  <div>
                    {rowData.yearofmanufacture ? rowData.yearofmanufacture : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Date Placed in Service")}`,
              field: "dateplacedinservice",
              hidden: true,
              hiddenByColumnsButton: true,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Date Placed in Service")}
                  </div>
                  <div>
                    {rowData.dateplacedinservice
                      ? rowData.dateplacedinservice
                      : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Life in Months")}`,
              field: "lifeinmonths",
              hidden: true,
              hiddenByColumnsButton: true,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Life in Months")}
                  </div>
                  <div>
                    {rowData.lifeinmonths ? rowData.lifeinmonths : "none"}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Original Cost")}`,
              field: "originalcost",
              hidden: true,
              hiddenByColumnsButton: true,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Original Cost")}
                  </div>
                  <div>{rowData.originalcost ? rowData.originalcost : ""}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Category")}`,
              field: "category_name",
              hidden: false,
              hiddenByColumnsButton: false,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Category")}
                  </div>
                  <div>
                    {rowData.category_name ? rowData.category_name : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Sub category Name")}`,
              field: "sub_category_name",
              hidden: false,
              hiddenByColumnsButton: false,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Sub category Name")}
                  </div>
                  <div>
                    {rowData.sub_category_name ? rowData.sub_category_name : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Status")}`,
              field: "status",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Status")}
                  </div>
                  <div>{rowData.status ? rowData.status : "None"}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              const { orderBy, orderDirection } = query;

              if (selectedValue2) {
                contractNumber = selectedValue2.contract_number;
              }
              if (selectedValueAsset) {
                assetNumber = selectedValueAsset.asset_number;
              }

              let url = API + "contracts/assetregister-view/?";
              url += "per_page=" + query.pageSize;
              url += "&page=" + (query.page + 1);
              url += "&search=" + query.search;
              url += `&contractNumber=${
                contractNumber !== "" ? contractNumber : ""
              }`;
              url += `&assetNumber=${assetNumber !== "" ? assetNumber : ""}`;
              url += `&status=${status !== "" ? status : ""}`;
              url += `&item_type=${asset_type !== "" ? asset_type : ""}`;
              url += `&category=${
                selected_category !== "" ? selected_category : ""
              }`;
              url += `&subcategory=${
                selected_sub_category !== "" ? selected_sub_category : ""
              }`;
              if (orderBy) {
                url += `&orderBy=${orderBy.field}`;
                url += `&orderDirection=${orderDirection}`;
              }
              fetch(url, { headers: authHeader() })
                .then((response) => response.json())
                .then((result) => {
                  setSummaryData(result.data.summary);
                  resolve({
                    data:
                      query.orderBy && query.orderDirection
                        ? _.orderBy(
                            result.data.results,
                            [query.orderBy.field],
                            [query.orderDirection]
                          )
                        : result.data.results,
                    page: result.page - 1,
                    totalCount: result.total,
                  });
                });
            })
          }
          actions={[
            (rowData) => ({
              icon: () =>
                permissionss &&
                permissionsArray.includes("change_itemmaster") === true ? (
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
                    alt="edit"
                  />
                ) : (
                  ""
                ),
              tooltip: "Edit",
              onClick:
                permissionss &&
                permissionsArray.includes("change_itemmaster") === true
                  ? (event, rowData) => {
                      handleEdit(rowData.id);
                    }
                  : "",
              // hidden: rowData.status === "Inventory" ? false : true
            }),
          ]}
          components={{
            Toolbar: (props) => (
              <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                <MTableToolbar {...props} />
                {/* {id === undefined &&  */}
                <span
                  onClick={() => setState({ isPaneOpen: true })}
                  style={{
                    color: "#b4b7c5",
                    paddingRight: "10px",
                    cursor: "pointer",
                  }}
                >
                  {/* <i class="fa fa-light fa-filter"></i> */}
                  <img
                    alt=""
                    src={
                      process.env.PUBLIC_URL + "/static/images/ic-filter.svg"
                    }
                  />
                </span>
                {/* } */}
              </div>
            ),
          }}
          options={{
            headerStyle: {
              backgroundColor: "white",
              color: "#245C7F",
              fontSize: 12,
            },
            rowStyle: (rowData, index) => {
              if (index % 2) {
                return { backgroundColor: "#fff" };
              }
            },
            sorting: true,
            search: true,
            exportButton: true,
            exportFileName: "Inventory Report",
            exportCsv: async (columns, data) => {
              try {
                const allData = await fetchAllDataForExport(); // Fetch all data
                if (allData.length === 0) {
                  console.error("No data found for CSV export");
                  return;
                }

                const csvColumns = [
                  ...Helper.visibleColumn(columns),
                  { title: "Manufacturer", field: "manufacturer" },
                  { title: "Year of Manufacture", field: "yearofmanufacture" },
                  {
                    title: "Date Placed in Service",
                    field: "dateplacedinservice",
                  },
                  { title: "Life in Months", field: "lifeinmonths" },
                  { title: "Original Cost", field: "originalcost" },
                ];
                const csvColumnTitles = csvColumns.map(
                  (column) => column.title
                );

                const title = "Inventory Report";
                const currentDate = new Date().toLocaleDateString();

                let csvContentWithInfo = `${title}\n`;
                if (inputvalue !== "") {
                  const selectedVal = inputvalue;
                  csvContentWithInfo += `Filter By Asset Number : ${selectedVal}\n`;
                }
                if (selectedValue2 !== null) {
                  const selectedVal2 = selectedValue2.contract_number;
                  csvContentWithInfo += `Filter By Contract Number : ${selectedVal2}\n`;
                }
                csvContentWithInfo += `Date: ${currentDate}\n\n`;

                const csvData = allData.map((rowData) =>
                  csvColumns.map((columnDef) => {
                    if (columnDef.field === "manufacturer") {
                      return rowData.manufacturer || "";
                    } else if (columnDef.field === "yearofmanufacture") {
                      return rowData.manufacturer || "";
                    } else if (columnDef.field === "dateplacedinservice") {
                      return rowData.manufacturer || "";
                    } else if (columnDef.field === "lifeinmonths") {
                      return rowData.manufacturer || "";
                    } else if (columnDef.field === "originalcost") {
                      return rowData.manufacturer || "";
                    } else if (columnDef.field === "customer_name") {
                      return rowData.customer_name ? rowData.customer_name : "";
                    } else if (
                      columnDef.field === "start_date" ||
                      columnDef.field === "end_date" ||
                      columnDef.field === "paymentstartdate"
                    ) {
                      return rowData[columnDef.field]
                        ? Helper.DateNormal(rowData[columnDef.field])
                        : "";
                    } else {
                      return rowData[columnDef.field];
                    }
                  })
                );

                const csvRows = [csvColumnTitles, ...csvData];
                const csvContent = `${csvContentWithInfo}${csvRows
                  .map((row) => row.join(","))
                  .join("\n")}`;

                const blob = new Blob([csvContent], {
                  type: "text/csv;charset=utf-8;",
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "Inventory.csv";
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } catch (error) {
                console.error("Error exporting CSV:", error);
              }
            },
            exportPdf: async (columns, data) => {
              const allData = await fetchAllDataForExport(); // Fetch all data
              if (allData.length === 0) {
                console.error("No data found for PDF export");
                return;
              }
              const visibleColumns = [
                ...Helper.visibleColumn(columns),
                { title: "Manufacturer", field: "manufacturer" },
                { title: "Year of Manufacture", field: "yearofmanufacture" },
                {
                  title: "Date Placed in Service",
                  field: "dateplacedinservice",
                },
                { title: "Life in Months", field: "lifeinmonths" },
                { title: "Original Cost", field: "originalcost" },
              ];

              const doc = new jsPDF();
              doc.setFont("helvetica", "bold");
              doc.setFontSize(16);

              const title = "Asset Report";
              doc.text(title, 14, 10);

              doc.setFontSize(12);
              doc.setFont("helvetica", "normal");
              const currentDate = new Date().toLocaleDateString();
              doc.text(`Date : ${currentDate}`, 14, 15);
              if (selectedValue2 !== null) {
                const selectedVal = inputvalue;
                const selectedVal2 = selectedValue2?.contract_number;
                if (inputvalue !== "" && selectedValue2 !== null) {
                  doc.text(
                    `Filter By Asset Number and Contract Number : ${
                      selectedVal === "" ? "" : selectedVal
                    } and ${selectedVal2 === "undefined" ? "" : selectedVal2}`,
                    14,
                    20
                  );
                } else if (inputvalue !== "") {
                  doc.text(
                    `Filter By  Asset Number : ${
                      selectedVal === "" ? "" : selectedVal
                    } `,
                    14,
                    20
                  );
                } else if (selectedValue2 !== null) {
                  doc.text(
                    `Filter By  Contract Number : ${
                      selectedVal2 === "undefined" ? "" : selectedVal2
                    }`,
                    14,
                    20
                  );
                }
              }

              const space = 22; // Adjust the space value as needed
              const tableStartY = 5 + space;

              const columnTitles = visibleColumns.map(
                (columnDef) => columnDef.title
              );
              const pdfData = allData.map((rowData) =>
                visibleColumns.map((columnDef) => {
                  if (columnDef.field === "manufacturer") {
                    return rowData.manufacturer || "";
                  } else if (columnDef.field === "yearofmanufacture") {
                    return rowData.manufacturer || "";
                  } else if (columnDef.field === "dateplacedinservice") {
                    return rowData.manufacturer || "";
                  } else if (columnDef.field === "lifeinmonths") {
                    return rowData.manufacturer || "";
                  } else if (columnDef.field === "originalcost") {
                    return rowData.manufacturer || "";
                  } else if (columnDef.field === "customer_name") {
                    return rowData.customer_name ? rowData.customer_name : "";
                  } else if (
                    columnDef.field === "start_date" ||
                    columnDef.field === "end_date" ||
                    columnDef.field === "paymentstartdate"
                  ) {
                    return rowData[columnDef.field]
                      ? Helper.DateNormal(rowData[columnDef.field])
                      : "";
                  } else {
                    return rowData[columnDef.field];
                  }
                })
              );
              const tableData = [columnTitles, ...pdfData];

              // Generate PDF table
              // doc.autoTable({
              autoTable(doc,{
                head: [tableData[0]], // Column headers
                body: tableData.slice(1), // Data excluding headers
                startY: tableStartY,
                columnStyles: getAlignmentStyles(visibleColumns), // Apply column alignment styles
              });

              doc.save(`Inventory.pdf`);
            },
            toolbar: true,
            paging: true,
            pageSize: 10, // make initial page size
            emptyRowsWhenPaging: false, // To avoid of having empty rows
            pageSizeOptions: [10, 15, 20, 50],
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            actionsColumnIndex: -1,
            columnsButton: true,
          }}
        />
      </div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        width="40% !important"
        isOpen={state1.isPaneOpen}
        title="Filter By"
        subtitle=""
        onRequestClose={() => {
          setState({ isPaneOpen: false });
        }}
      >
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">
              {t("Contract Number")}
            </label>
            <div className="col-lg-12">
              <Select
                value={selectedValue2}
                filterOption={false}
                options={options2}
                isClearable
                onInputChange={handleInputChangeData}
                getOptionLabel={(options) => options.contract_number}
                getOptionValue={(options) => options.contract_number}
                isLoading={isLoading2}
                placeholder={t("Search for Contract(%for All)")}
                onMenuScrollToBottom={handleMenuScrollToBottom}
                onChange={handelChange2}
              />
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">
              {t("Asset Number")}
            </label>
            <div className="col-lg-12">
              {/* <input
                className="form-control" 
                onChange={(e) => handlechangeAsset(e.target.value)}
              /> */}
              <Select
                value={selectedValueAsset}
                filterOption={false}
                options={optionsAsset}
                isClearable
                onInputChange={handleInputAssetChangeData}
                getOptionLabel={(options) => options.asset_number}
                getOptionValue={(options) => options.asset_number}
                isLoading={isLoadingAsset}
                placeholder={t("Search for Asset(%for All)")}
                onMenuScrollToBottom={handleAssetMenuScrollToBottom}
                onChange={handlechangeAsset}
              />
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">{t("Status")}</label>
            <div className="col-lg-12">
              <select
                className="form-control"
                name="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                <option value="Inventory">Inventory</option>
                <option value="Available for Lease">Available for Lease</option>
                <option value="Available for Rent">Available for Rent</option>
                <option value="Available for Sale">Available for Sale</option>
                <option value="In Transit">In Transit</option>
                <option value="Leased">Leased</option>
                <option value="Rented">Rented</option>
                <option value="Scrapped">Scrapped</option>
                <option value="Sold">Sold</option>
              </select>
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">{t("Item Type")}</label>
            <div className="col-lg-12">
              <select
                className="form-control"
                name="item_type"
                value={asset_type}
                onChange={(e) => setAsset_type(e.target.value)}
              >
                <option value="">Select Value</option>
                <option value="Vehicle">Vehicle</option>
                <option value="Equipment">Equipment</option>
              </select>
            </div>
            <input type="hidden" id="contract_status" value="" />
          </div>
        </div>
        <div className="form-group row">
          <div className="col-sm-6">
            <label className="col-form-label ">{t("Category")} </label>
            <select
              className="form-control"
              name="category"
              onChange={(e) => {
                handleCategoryChange(e);
              }}
              // {...register("category", { onChange: (e) => { handleCategoryChange(e) }, required: true })}
              value={selected_category}
            >
              <option value="">Select Category</option>
              {category_list.map((val, i) => (
                <option key={i} value={val.id}>
                  {val.category_name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-6">
            <label className="col-form-label ">{t("Sub Category")} </label>
            <select
              className="form-control"
              name="subcategory"
              value={selected_sub_category}
              onChange={(e) => {
                handlesubCategoryChange(e);
              }}
              // {...register("subcategory", { onChange: (e) => { handlesubCategoryChange(e) }, required: true })}
            >
              <option value="">Select Subcategory</option>
              {sub_categories.map((val) => (
                <option key={val.id} value={val.id}>
                  {val.sub_category_name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
              <button
                type="button"
                className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                onClick={handleClear}
              >
                {t("Reset")}
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="filter add btn btn-primary btn-m ms-auto mb-0"
                onClick={() => Helper.handleSearch(tableRef)}
              >
                {t("Apply")}
              </button>
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </SlidingPane>
      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        PaperProps={{
          style: {
            width: "600px",
            maxWidth: "90%",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle
          style={{
            fontWeight: "bold",
            color: "#1E88E5",
            borderBottom: "1px solid #E0E0E0",
            paddingBottom: "10px",
          }}
        >
          {t("Inventory Register")}
        </DialogTitle>
        <DialogContent>
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "10px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      backgroundColor: "#E3F2FD",
                      color: "#1565C0",
                      fontWeight: "bold",
                      borderBottom: "2px solid #B0BEC5",
                    }}
                  >
                    Category
                  </th>
                  <th
                    style={{
                      textAlign: "right",
                      padding: "10px",
                      backgroundColor: "#E3F2FD",
                      color: "#1565C0",
                      fontWeight: "bold",
                      borderBottom: "2px solid #B0BEC5",
                    }}
                  >
                    Total
                  </th>
                  <th
                    style={{
                      textAlign: "right",
                      padding: "10px",
                      backgroundColor: "#E3F2FD",
                      color: "#1565C0",
                      fontWeight: "bold",
                      borderBottom: "2px solid #B0BEC5",
                    }}
                  >
                    Percentage
                  </th>
                </tr>
              </thead>
              <tbody>
                {summaryData.map(({ category, total, percentage }) => (
                  <tr
                    key={category}
                    style={{
                      backgroundColor: "transparent",
                      borderBottom: "1px solid #F5F5F5",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px",
                        color: "#757575",
                        // fontWeight: "bold",
                      }}
                    >
                      {category}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        color: "#757575",
                        textAlign: "right",
                        // fontWeight: "bold",
                      }}
                    >
                      {(total)}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "right",
                        color: "#757575",
                        // fontWeight: "bold",
                      }}
                    >
                      {percentage.toFixed(2)}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDialogClose}
            color="primary"
            style={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#1E88E5",
            }}
          >
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AssetRegister;
